"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const __1 = require("../..");
const Loader = () => {
    return (React.createElement("div", null,
        React.createElement("style", { media: "screen" }, `#loading-indicator rect:nth-child(1) {
                animation: pulse 1200ms ease-out infinite;
            }

            #loading-indicator rect:nth-child(2) {
                animation: pulse 1200ms ease-in-out 400ms infinite;
            }

            #loading-indicator rect:nth-child(3) {
                animation: pulse 1200ms ease-in-out 800ms infinite;
            }

            @keyframes pulse {
                11%, 44% {
                    fill: ${__1.titanium};
                }

                22%, 33% {
                    fill: ${__1.cloud};
                }
            }`),
        React.createElement("svg", { id: "loading-indicator", width: "48", height: "24", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("g", { fill: "none", fillRule: "evenodd" },
                React.createElement("rect", { fill: __1.titanium, x: "3", y: "7", width: "10", height: "10", rx: "2" }),
                React.createElement("rect", { fill: __1.titanium, x: "19", y: "7", width: "10", height: "10", rx: "2" }),
                React.createElement("rect", { fill: __1.titanium, x: "35", y: "7", width: "10", height: "10", rx: "2" })))));
};
exports.default = Loader;
